
import {Vue, Component, Prop} from 'vue-property-decorator';
import DownloadLin33 from "@/components/DownloadLin33.vue";
import PlatformChoice from "@/components/PlatformChoice.vue";
import DownloadWin33 from "@/components/DownloadWin33.vue";
import DownloadMac33 from "@/components/DownloadMac33.vue";
import DownloadZip33 from "@/components/DownloadZip33.vue";
import License from "@/components/License.vue";

@Component({
  components: {License, DownloadZip33, DownloadMac33, DownloadWin33, PlatformChoice, DownloadLin33}
})
export default class CheckoutSuccess extends Vue {
  @Prop() txnId;
  @Prop() platform;
  @Prop() amount;

  // Purchases of this amount or more come with a GanttProject Cloud promo code worth 5 credits.
  private PROMO_MIN_AMOUNT = 10;
  private promoState: "idle" | "pending" | "success" | "error" = "idle";
  private promoCode = "";

  private get isPromoCodeEligible(): boolean {
    return this.amount >= this.PROMO_MIN_AMOUNT;
  }

  mounted() {
    if (this.isPromoCodeEligible) {
      this.registerPromoCode();
    }
  }

  private async registerPromoCode() {
    this.promoState = "pending";
    try {
      const response = await fetch("/api/promo/register", {
        method: "POST",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        body: new URLSearchParams({code: this.txnId})
      });
      if (response.ok) {
        const data = await response.json();
        this.promoCode = data.code;
        this.promoState = "success";
      } else {
        console.error("Failed to register the promo code: HTTP " + response.status);
        this.promoState = "error";
      }
    } catch (e) {
      console.error("Failed to register the promo code", e);
      this.promoState = "error";
    }
  }

  private cdnUrl(path: string): string {
    return path;
  }

  private versionShort = "3.3";
  private version = "3.3.3316";
  private releaseDate = "30 Jan, 2025";
  private winMsiSize = "132 Mb";
  private winMsiMd5 = "65d8eb2653878309c4b809c1559268a9";
  private winMsiVirusTotal = "3a7f6804686937140dce07a7abc73e27f8b3d58a5dd650f51d8865f2580807d9";
  private winExeSize = "130 Mb";
  private winExeMd5 = "9505f15f583b155c52c6f50aa225e263";
  private winExeVirusTotal = "fca6588d97615ce1f293d554fcebdc6c3f40d46ebd4eb6c1b117ca5f31f6b3e1";
  private macSiliconSize = "132 Mb";
  private macIntelSize = "136 Mb";
  private linSize = "93 Mb";
  private zipSize = "52 Mb";
}
